var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"historyOfPurchaseOrders"},[_c('q-pull-to-refresh',{staticClass:"pullRefresh",on:{"refresh":_vm.refresh}},[_c('DataCard',{attrs:{"data":_vm.allFilters,"fields":_vm.fields,"filterData":""},on:{"cardClick":_vm.detailOrder,"filterR":_vm.getAPI}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }